import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { CaseDetailsContainer } from './v1/index.container';

interface IdentityVerificationVersionRouterProps {
  isApplicantSection?: boolean;
}

export const IdentityVerificationVersionRouter: React.FC<IdentityVerificationVersionRouterProps> = (props) => {
  return (
    <Routes>
      <Route path="v1/*" element={<CaseDetailsContainer isApplicantSection={props.isApplicantSection} />} />
    </Routes>
  );
};
